
// src/context/SettingsContext.js
import React, { createContext, useState } from 'react';

export const SettingsContext = createContext();

export function SettingsProvider({ children }) {
  const [loudnessSettings, setLoudnessSettings] = useState(null);
  const [mclSettings, setMclSettings] = useState(null);
  const [level, setLevel] = useState(1);
  const [hasSavedLoudness, setHasSavedLoudness] = useState(false);
  const [hasSavedMCL, setHasSavedMCL] = useState(false);

  return (
    <SettingsContext.Provider value={{
      loudnessSettings, setLoudnessSettings,
      mclSettings, setMclSettings,
      level, setLevel,
      hasSavedLoudness, setHasSavedLoudness,
      hasSavedMCL, setHasSavedMCL
    }}>
      {children}
    </SettingsContext.Provider>
  );
}
